import styled from 'styled-components';
import { media } from '../../styles/theme';

export const Container = styled.form`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.espaco.lg};
  width: 100%;
`;

export const InputsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.espaco.md};
  padding: ${({ theme }) => theme.espaco.xl};
  background-color: ${({ theme }) => theme.cores.card};
  border: 1px solid ${({ theme }) => theme.cores.border};
  border-radius: ${({ theme }) => theme.raio.card};

  ${media.mobile} {
    padding: ${({ theme }) => theme.espaco.lg};
  }
`;

// Largura do campo pelo laytel.porfic (%); sem porfic, divide o espaço com mínimo de 240px
export const CampoFicha = styled.div<{ $porfic?: string }>`
  ${({ $porfic }) => (Number($porfic) > 0
    ? `flex: 0 0 calc(${Math.min(Number($porfic), 100)}% - 12px);`
    : 'flex: 1 1 240px;')}
  min-width: 0;

  ${media.mobile} {
    flex: 1 1 100%;
  }
`;

export const Acoes = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: ${({ theme }) => theme.espaco.sm};

  ${media.mobile} {
    /* Barra fixa no rodapé da tela, botões em largura total */
    position: sticky;
    bottom: 0;
    margin: 0 -${({ theme }) => theme.espaco.lg} -${({ theme }) => theme.espaco.lg};
    padding: ${({ theme }) => theme.espaco.md} ${({ theme }) => theme.espaco.lg};
    background-color: ${({ theme }) => theme.cores.card};
    border-top: 1px solid ${({ theme }) => theme.cores.border};
    z-index: 2;

    button {
      flex: 1;
    }
  }
`;
